import { createSlice } from '@reduxjs/toolkit';
import { LABELGENAPI} from '../../../API';
import { OMSAUTH, OMSPROFILE } from '../../../API';
import { logFrontendActivity } from '../../General/activityLogger';

export const subusersslice = createSlice({
    name: 'subusers',
    initialState: {
        data: [],
        meta: [],
        loading: false,
        hasErrors: false,
        notification: { show: false, messageContent: "", messageType: "success" }
    },
    reducers: {
        getSubusersData: (state) => {
            return {
                ...state,
                loading: true,
                hasErrors: false
            }
        },
        getSubusersDataSuccess: (state, action) => {
            return {
                ...state,
                data: action && action.payload && action.payload.data && action.payload.data.data,
                notification: { show: true, messageContent: [action && action.payload && action.payload.data && action.payload.data.message], messageType: "success" },
                hasErrors: false,
                loading: false
            }
        },
        getSubusersDataFailure: (state, action) => {
            return {
                ...state,
                loading: false,
                hasErrors: true,
                notification: { show: true, messageContent: [action && action.payload && action.payload.data && action.payload.data.message], messageType: "error" }
            }
        },
        postSubusersData: (state) => {
            return {
                ...state,
                loading: true,
                hasErrors: false
            }
        },
        postSubusersDataSuccess: (state, action) => {
            return {
                ...state,
                hasErrors: false,
                loading: false,
                notification: { show: true, messageContent: [action && action.payload && action.payload.data && action.payload.data.data && action.payload.data.data.message], messageType: "success" }
            }
        },
        postSubusersDataFailure: (state, action) => {
            return {
                ...state,
                loading: false,
                hasErrors: true,
                notification: { show: true, messageContent: [action && action.payload && action.payload.data && action.payload.data.data && action.payload.data.data.message], messageType: "error" }
            }
        },
        putSubusersData: (state) => {
            return {
                ...state,
                loading: true,
                hasErrors: false
            }
        },
        putSubusersDataSuccess: (state, action) => {
            return {
                ...state,
                hasErrors: false,
                loading: false,
                notification: { show: true, messageContent: [action && action.payload && action.payload.data && action.payload.data.data && action.payload.data.data.message], messageType: "success" }
            }
        },
        putSubusersDataFailure: (state, action) => {
            return {
                ...state,
                loading: false,
                hasErrors: true,
                notification: { show: true, messageContent: [action && action.payload && action.payload.data && action.payload.data.data && action.payload.data.data.message], messageType: "error" }
            }
        },
        deleteSubusersData: (state) => {
            return {
                ...state,
                loading: true,
                hasErrors: false
            }
        },
        deleteSubusersDataSuccess: (state, action) => {
            return {
                ...state,
                hasErrors: false,
                loading: false,
                notification: { show: true, messageContent: [action && action.payload && action.payload.data && action.payload.data.data && action.payload.data.data.message], messageType: "success" }
            }
        },
        deleteSubusersDataFailure: (state, action) => {
            return {
                ...state,
                loading: false,
                hasErrors: true,
                notification: { show: true, messageContent: [action && action.payload && action.payload.data && action.payload.data.data && action.payload.data.message], messageType: "error" }
            }
        },

        resetSubusers: (state) => {
            return {
                ...state,
                loading: false,
                hasError: false,
                notification: { show: false, messageContent: "", messageType: "success" }
            }
        },


    }
})
export const { getSubusersData, getSubusersDataSuccess, getSubusersDataFailure, postSubusersData, postSubusersDataSuccess, postSubusersDataFailure,
    putSubusersData, putSubusersDataSuccess, putSubusersDataFailure,
    deleteSubusersData, deleteSubusersDataSuccess, deleteSubusersDataFailure,resetSubusers } = subusersslice.actions;


export const fetchSubusersData = () => dispatch => {
    dispatch(getSubusersData());
    try {
        OMSAUTH
            .get("/subuser")
            .then(function (response) {
                dispatch(getSubusersDataSuccess(response));
            })
            .catch(function (error) {
                dispatch(getSubusersDataFailure(error.response));
            });
    } catch (error) {
        dispatch(getSubusersDataFailure());
    }
};

export const storeSubusersData = (userid,data) => dispatch => {
    dispatch(postSubusersData());
    const logRef = crypto.randomUUID();
    try {
        OMSAUTH.post('/subuser', data, { 
            headers: { 
                'x-log-ref': logRef
                 } 
            })
            .then(function (response) {
                dispatch(postSubusersDataSuccess(response));
                dispatch(fetchSubusersData());
                logFrontendActivity({
                    group: 'SETTINGS',
                    subgroup: 'SUBUSER_CREATE',
                    action: 'SUCCESS',
                    request_data: data,
                    response_data: response.data,
                    log_ref: logRef,
                    userid: userid
                }).then((ref) => {
                    if (ref) {
                        console.log('Activity log recorded with log_ref:', ref);
                    }else{
                        console.log('Activity log failed:', ref);
                    }
                });
            }).catch(function (error) {
                dispatch(postSubusersDataFailure(error.response));
                logFrontendActivity({
                    group: 'SETTINGS',
                    subgroup: 'SUBUSER_CREATE',
                    action: 'FAILURE',
                    request_data: data,
                    response_data: error.response?.data || {},
                    log_ref: logRef,
                    userid: userid
                }).then((ref) => {
                    if (ref) {
                        console.log('Activity log recorded with log_ref:', ref);
                    }
                });
            })
    }
    catch (error) {
        dispatch(postSubusersDataFailure(error.response));
        logFrontendActivity({
            group: 'SETTINGS',
            subgroup: 'SUBUSER_CREATE',
            action: 'FAILURE',
            request_data: data,
            response_data: error.response?.data || {},
            log_ref: logRef,
            userid: userid
        }).then((ref) => {
            if (ref) {
                console.log('Activity log recorded with log_ref:', ref);
            }
        });
    }
}
export const updateSubusersData = (userid,data) => dispatch => {
    dispatch(putSubusersData());
    const logRef = crypto.randomUUID();
    try {
        OMSAUTH.put('/subuser/' + data.id, data, { 
            headers: { 
                'x-log-ref': logRef
                 } 
            })
            .then(function (response) {
                dispatch(putSubusersDataSuccess(response));
                dispatch(fetchSubusersData());
                logFrontendActivity({
                    group: 'SETTINGS',
                    subgroup: 'SUBUSER_UPDATE',
                    action: 'SUCCESS',
                    request_data: data,
                    response_data: response.data,
                    log_ref: logRef,
                    userid: userid
                }).then((ref) => {
                    if (ref) {
                        console.log('Activity log recorded with log_ref:', ref);
                    }else{
                        console.log('Activity log failed:', ref);
                    }
                });
            }).catch(function (error) {
                dispatch(putSubusersDataFailure(error.response));
                logFrontendActivity({
                    group: 'SETTINGS',
                    subgroup: 'SUBUSER_UPDATE',
                    action: 'FAILURE',
                    request_data: data,
                    response_data: error.response?.data || {},
                    log_ref: logRef,
                    userid: userid
                }).then((ref) => {
                    if (ref) {
                        console.log('Activity log recorded with log_ref:', ref);
                    }
                });
            })
    }
    catch (error) {
        dispatch(putSubusersDataFailure(error.response));
        logFrontendActivity({
            group: 'SETTINGS',
            subgroup: 'SUBUSER_UPDATE',
            action: 'FAILURE',
            request_data: data,
            response_data: error.response?.data || {},
            log_ref: logRef,
            userid: userid
        }).then((ref) => {
            if (ref) {
                console.log('Activity log recorded with log_ref:', ref);
            }
        });
    }
}
export const destorySubusersData = (userid,id) => dispatch => {
    dispatch(deleteSubusersData());
    const logRef = crypto.randomUUID();
    try {
        OMSAUTH
            .delete("/subuser/" + id, { 
            headers: { 
                'x-log-ref': logRef
                 } 
            })
            .then(function (response) {
                dispatch(deleteSubusersDataSuccess(response));
                dispatch(fetchSubusersData());
                logFrontendActivity({
                    group: 'SETTINGS',
                    subgroup: 'SUBUSER_DELETE',
                    action: 'SUCCESS',
                    request_data: JSON.stringify(id),
                    response_data: response.data,
                    log_ref: logRef,
                    userid: userid
                }).then((ref) => {
                    if (ref) {
                        console.log('Activity log recorded with log_ref:', ref);
                    }else{
                        console.log('Activity log failed:', ref);
                    }
                });
            })
            .catch(function (error) {
                dispatch(deleteSubusersDataFailure(error.response));
                logFrontendActivity({
                    group: 'SETTINGS',
                    subgroup: 'SUBUSER_DELETE',
                    action: 'FAILURE',
                    request_data: JSON.stringify(id),
                    response_data: error.response?.data || {},
                    log_ref: logRef,
                    userid: userid
                }).then((ref) => {
                    if (ref) {
                        console.log('Activity log recorded with log_ref:', ref);
                    }
                });
            });
    } catch (error) {
        dispatch(deleteSubusersDataFailure(error));
        logFrontendActivity({
            group: 'SETTINGS',
            subgroup: 'SUBUSER_DELETE',
            action: 'FAILURE',
            request_data: JSON.stringify(id),
            response_data: error.response?.data || {},
            log_ref: logRef,
            userid: userid
        }).then((ref) => {
            if (ref) {
                console.log('Activity log recorded with log_ref:', ref);
            }
        });
    }
};
export const resetSubusersState = data => dispatch => {
    dispatch(resetSubusers());
}

export default subusersslice.reducer;
